// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-D3g-2TKX","fhlx":"fhlx-2Jxijtoe clearfix","mr24":"mr24-1RN6gmPX fl","img":"img-1uZpjmiU","lx_word":"lx_word-vMkrkVxZ fl"};